import {ETHICAL_WILLS_LOADING, ETHICAL_WILLS_LOADED, ETHICAL_WILLS_FAILED} from '../actions/corpMaxActionTypes'

/**
 * Tracks whether the session's ethical wills have been fetched. The resources
 * themselves live in the redux-json-api store, but an empty collection leaves
 * no trace there, so this is the source of truth for "fetched at least once".
 *
 * A failed fetch is kept distinct from 'loaded' so consumers don't mistake a
 * network error for "no life stories exist"; it retries on the next mount.
 */
const ethicalWillsStatusReducer = (state = 'initial', action) => {
  switch (action.type) {
    case ETHICAL_WILLS_LOADING:
      return state === 'loaded' ? state : 'loading'
    case ETHICAL_WILLS_LOADED:
      return 'loaded'
    case ETHICAL_WILLS_FAILED:
      return state === 'loaded' ? state : 'failed'
    default:
      return state
  }
}

export default ethicalWillsStatusReducer
